// React
import { useNavigate } from "react-router-dom";
// Recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { cartState, isOrderState, paymentData } from "../../atom/menu";
import { useEffect } from "react";

function OrderConfirm() {
  // 주문확인 페이지

  const navigate = useNavigate();
  // Recoil State
  const setIsOrder = useSetRecoilState(isOrderState);
  const cartData = useRecoilValue(cartState);
  const [payment, setPayment] = useRecoilState(paymentData);

  // Function
  function calcTotalAmount() {
    // 총액 계산
    if (cartData) {
      let amt = 0 as number;
      let option = 0 as number;
      cartData.reduce((acc, cur) => {
        if (cur.option) {
          cur.option.reduce((acc2, cur2) => {
            option = acc2 + cur2.price * cur2.ea;
            return option;
          }, option);
          amt = acc + (cur.price + option) * cur.ea;
        } else {
          amt = acc + cur.price * cur.ea;
        }
        return amt;
      }, amt);
      let total = amt as number;
      return total;
    } else {
      return 0;
    }
  }
  const calcTotalEa = () => {
    let total = 0 as number;
    if (cartData) {
      cartData.reduce((acc, cur) => {
        total = acc + cur.ea;
        return total;
      }, total);
    }
    return total;
  };
  useEffect(() => {
    setPayment({ ...payment, totalAmount: calcTotalAmount() });
  }, []);
  function calcProductPrice(idx: number) {
    if (cartData) {
      let price = 0 as number;
      let option = 0 as number;
      price = cartData[idx].price;
      if (cartData[idx].option) {
        cartData[idx].option!.reduce((acc, cur) => {
          option = acc + cur.price * cur.ea;
          return option;
        }, option);
      }
      return (price + option) * cartData[idx].ea;
    } else {
      return 0;
    }
  }

  return (
    <div
      className='intro-wrap'
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        zIndex: 99,
        backgroundColor: "#eeeeeeed",
      }}
    >
      <div className='flex row h-auto'>
        <div
          className='menu-intro-wrap h-auto'
          style={{
            justifyContent: "center",
            paddingLeft: 58,
          }}
        >
          <div className='TO-title-1 align-self-left'>주문 이후엔</div>
          <div
            className='TO-title-1 align-self-left'
            style={{ color: "#f93822" }}
          >
            취소가 어렵습니다
          </div>
          <div className='TO-body-2 align-self-left' style={{ paddingTop: 40 }}>
            총{" "}
            <span style={{ color: "#f93822" }}>
              {calcTotalEa()?.toLocaleString()}개
            </span>
            의 메뉴를 주문하시겠습니까?
          </div>
          <div className='TO-body-2 align-self-left'>
            주문서를 반드시 확인해주세요
          </div>
        </div>
        <div
          className='menu-intro-wrap'
          style={{ paddingTop: 56, paddingBottom: 10 }}
        >
          <div className='order-paper-wrap'>
            <div className='TO-button-2' style={{ textAlign: "center" }}>
              주문서
            </div>
            <div
              className='order-row text-color-gray-5'
              style={{ padding: "4px 0", borderBottom: "1px solid #BFBFBF" }}
            >
              <div>메뉴</div>
              <div style={{ padding: 0 }}>수량</div>
              <div style={{ padding: 0 }}>가격</div>
            </div>
            <div className='scroll' style={{ paddingTop: 16 }}>
              {cartData?.map((v, idx) => {
                return (
                  <div className='order-menu-wrap'>
                    <div className='order-row'>
                      <div
                        className='TO-body-1'
                        style={{
                          color: "#303030",
                        }}
                      >
                        {v.name}
                      </div>
                      <div className='TO-price-5'>{v.ea}</div>
                      <div className='TO-price-5'>
                        {calcProductPrice(idx).toLocaleString()}
                      </div>
                    </div>
                    {v.option &&
                      v.option.map((option) => {
                        return (
                          <div className='order-row text-color-gray-5'>
                            <div className='TO-option-2'>{option.name}</div>
                            <div className='TO-price-5'></div>
                            <div className='TO-option-2'>
                              {option.price.toLocaleString()}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                );
              })}
            </div>
            <div className='flex col h-auto'>
              <div
                className='order-row TO-button-2'
                style={{ color: "#303030", marginTop: 20 }}
              >
                <div>합계</div>
                <div>{calcTotalEa()?.toLocaleString()}</div>
                <div>{calcTotalAmount()?.toLocaleString()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='menu-intro-button' style={{ padding: "14px 24px 16px" }}>
        <div
          className='basic-btn white TO-button-1 pointer'
          style={{ maxWidth: 208 }}
          onClick={() => {
            setIsOrder(false);
          }}
        >
          취소
        </div>
        <div
          className='basic-btn TO-button-1 pointer w-100'
          onClick={() => {
            navigate("/menu/order/membership");
          }}
        >
          총 {calcTotalEa()?.toLocaleString()}개 메뉴 주문하기
        </div>
      </div>
    </div>
  );
}
export default OrderConfirm;
